export type BundleTrack = {
  title: string;
};

function normalizeWords(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");
}

function hasPhrase(words: string, phrase: string): boolean {
  return Boolean(phrase) && ` ${words} `.includes(` ${phrase} `);
}

export function suggestTrackIndex(
  fileTitle: string,
  tracks: BundleTrack[],
): number | undefined {
  const fileWords = normalizeWords(fileTitle);
  if (!fileWords) return undefined;

  const candidates = new Set<number>();
  tracks.forEach((track, index) => {
    const titleWords = normalizeWords(track.title);
    if (titleWords && hasPhrase(fileWords, titleWords)) {
      candidates.add(index);
    }

    const number = String(index + 1);
    if (
      hasPhrase(fileWords, `track ${number}`) ||
      hasPhrase(fileWords, `track${number}`) ||
      hasPhrase(fileWords, `t${number}`)
    ) {
      candidates.add(index);
    }
  });

  return candidates.size === 1 ? [...candidates][0] : undefined;
}

export function isValidTrackIndex(
  trackIndex: number | undefined,
  trackCount: number,
): trackIndex is number {
  return (
    Number.isInteger(trackIndex) &&
    trackIndex !== undefined &&
    trackIndex >= 0 &&
    trackIndex < trackCount
  );
}
